import { useQuery } from '@tanstack/react-query';
import { apiService } from '../utils/serviceApi';

const fetchGasStationMapData = async (selectedGSZIds , dateRange) => {
  const response = await apiService.post(
    `${process.env.REACT_APP_SERVICE_URL}/api/gas-station/gas-station-map-data`,
    {
        selectedGSZIds,
        dateRange
    }
  );
  return response.data;
};

export const useGasStationMapData = ({ selectedGSZIds, dateRange, enabled = true }) => {
  return useQuery({
    queryKey: ['gasStationMapData', selectedGSZIds, dateRange],
    queryFn: () => fetchGasStationMapData(selectedGSZIds, dateRange),
    enabled: enabled && Array.isArray(selectedGSZIds) && selectedGSZIds.length > 0,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
